// import flatpickr from 'flatpickr' // flatpickr
// import 'flatpickr/dist/l10n/ja' // flatpickr日本語化

if (document.getElementById('system-favorite-tag')) {
  favorite()
}

function favorite() {
  //  #####   ######  ##     ##
  //  ##  ##    ##    ####   ##
  //  #####     ##    ##  ## ##  ########
  //  ##  ##    ##    ##    ###
  //  #####     ##    ##     ##

  //    ###    ####    ####
  //   ## ##   ##  ##  ##  ##
  //  ##   ##  ##  ##  ##  ##
  //  #######  ##  ##  ##  ##
  //  ##   ##  ####    ####

  // お気に入りに追加
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-favoriteTag')) {
      return
    }

    if (!e.target.classList.contains('active')) {
      e.target.classList.add('active')

      window.popToast('お気に入りタグに追加しました。')
    } else {
      e.target.classList.remove('active')
      window.popToast('お気に入りタグから削除しました。')
    }

    // お気に入り済み表示更新
    favoriteView()
  })

  //  ##   ##  ##  #####  ##      ##
  //  ##   ##  ##  ##     ##      ##
  //  ##   ##  ##  #####  ##  ##  ##
  //   ## ##   ##  ##     ##  ##  ##
  //    ###    ##  #####   ###  ###
  // お気に入りに入っているかを判定して表示を切り替える
  function favoriteView() {
    // 判定対象に.activeがついているかどうかを判定
    const btnList = document.getElementsByClassName('js-favorite')
    let isFav = false
    for (const item of btnList) {
      if (item.classList.contains('active')) {
        isFav = true
        break
      }
    }

    // 切り替え対象を切り替え
    const targetList = document.getElementsByClassName('js-favoriteView')
    if (isFav) {
      for (const item of targetList) {
        item.classList.add('active')
      }
    } else {
      for (const item of targetList) {
        item.classList.remove('active')
      }
    }
  }
}
